import { faPen, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, SxProps, useTheme } from '@mui/material';
import React from 'react';

export type InfoRowItemProps = {
    info?: React.ReactNode;
    icon?: IconDefinition;
    actions?: React.ReactNode[];
    singleActionIcon?: IconDefinition;
    singleActionOnClick?: () => void;
    rowSx?: SxProps;
    infoWrapperSx?: SxProps;
    infoSx?: SxProps;
    iconSx?: SxProps;
};

/**
 *
 * Create a row that can contain an icon, a react node like text infos and one or mulitple icon with onClick action
 * actions can contains multiple react element, by default an edit action is set using
 *
 * @returns React.ReactNode
 */
const InfoRowItemWithActions: React.FunctionComponent<InfoRowItemProps> = function ({
    info,
    icon,
    singleActionIcon,
    singleActionOnClick,
    // actions can return an array of tsx or by default a single one with a onClick action
    actions = [
        <Box
            key="action-default"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
            }}
            data-testid="action-default"
            onClick={singleActionOnClick || (() => {})}
        >
            <FontAwesomeIcon
                icon={singleActionIcon || faPen}
                data-testid="action-default-icon"
            />
        </Box>,
    ],
    rowSx,
    infoWrapperSx,
    infoSx,
    iconSx,
}) {
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: `solid 1px ${palette.grey[300]}`,
                borderRadius: '12px',
                padding: '16px 8px',
                minHeight: '90px',
                ...rowSx,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', ...infoWrapperSx }}>
                {icon && (
                    <Box
                        sx={{
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '24px',
                            color: palette.grey[600],
                            ...iconSx,
                        }}
                    >
                        <FontAwesomeIcon icon={icon} />
                    </Box>
                )}
                {info && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', ...infoSx }}>{info}</Box>
                )}
            </Box>

            {actions.map((action) => action)}
        </Box>
    );
};

export default InfoRowItemWithActions;
